import React from 'react';
import PropTypes from 'prop-types';

export const Icon = (props) => {
  const { iconName, size, className, focusable } = props;
  const style = {
    fontSize: `${size}px`,
  };
  let focusableProps;
  if (!focusable) {
    focusableProps = {
      tabIndex: '-1',
      'aria-hidden': true,
    };
  }
  return (
    <span style={style} className={className} {...focusableProps}>
      <span className={`icon ${iconName}`} />
    </span>
  );
};

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  focusable: PropTypes.bool,
};

Icon.defaultProps = {
  className: undefined,
  size: 16,
  focusable: true,
};

export default React.memo(Icon);
